import React from 'react';
import { FlightDetails } from '../interface/flight.details';
import moment from 'moment';
import { BUCKET_URL } from '../utils/env-utils';
import FlipText from './FlipText';
import AnimatedCodeshare from './AnimatedCodeshare';
import Destination from './Destination';
import './SingleFlightCheckIn.css';
import { getRemarksTranslation, normalizeCode } from '../utils/common.utils';
import { RemarkToCodeMapping } from '@industronics/fids-utils';


interface SingleFlightBoardingProps {
  flight: FlightDetails
}
const SingleFlightCheckIn: React.FC<SingleFlightBoardingProps> = ({ flight }) => {

  if (flight?.checkInType?.name === "C") {
    return (
      <div>
        <img
          style={{ width: "-webkit-fill-available" }}
          src={`${BUCKET_URL}/1920x0980/${flight?.flightNumber?.split(' ')[0]
            }.bmp`}
          onError={(e) => {
            ; (
              e.currentTarget as HTMLImageElement
            ).src = `${BUCKET_URL}/1920x0980/${flight?.flightNumber?.split(' ')[0]
            }.jpg`
          }}
          alt="Airline Logo" />
      </div>
    )
  }
  return (
    <div className="design5-container">
      {/* First Column - Left Side Content */}
      <div className="design5-column1">
        <div className="design5-info-left">
          {/* Date & Time */}
          <div className='design5-date'>
            {/* <Time /> */}

          </div>

          {/* Schedule Departure */}
          <div className="design5-schedule-departure">
            <div style={{ marginTop: '-20px', fontSize: '2rem' }} className="design5-schedule-label">Scheduled departure time</div>
            <div className="design5-schedule-time">
              {flight?.scheduledTravelTime && (
                <span
                  className="bp-time-value"
                  style={{ fontSize: '60px' }}
                >
                  {moment(flight?.scheduledTravelTime).format('HH:mm')}

                  {!moment(flight?.scheduledTravelTime)
                    .utcOffset(8)
                    .isSame(moment(), 'day') && (
                      <span>
                        <br />
                        <span style={{ color: 'yellow' }}>
                          {moment(flight?.scheduledTravelTime).format(
                            'DD MMM'
                          )}
                        </span>
                      </span>
                    )}
                </span>
              )}
            </div>
            <hr style={{ marginTop: '-14px' }} className="design5-separator" />
          </div>

          {/* Estimated Departure */}
          <div className="design5-estimated-departure">
            <div style={{ marginTop: '-10px' }} className="design5-estimated-label">Estimated departure time</div>
            <div className="design5-schedule-time">{(flight?.ETA || flight?.scheduledTravelTime) && (
              <span
                className="bp-time-value"
                style={{ fontSize: '60px' }}
              >
                {moment(flight?.ETA || flight?.scheduledTravelTime).format('HH:mm')}

                {!moment(flight?.ETA || flight?.scheduledTravelTime)
                  .utcOffset(8)
                  .isSame(moment(), 'day') && (
                    <span>
                      <br />
                      <span style={{ color: 'yellow', marginTop: '-20px' }}>
                        {moment(flight?.ETA || flight?.scheduledTravelTime).format(
                          'DD MMM'
                        )}
                      </span>
                    </span>
                  )}
              </span>
            )}</div>
            <hr style={{ marginTop: '-10px' }} className="design5-separator" />
          </div>

          {/* Gate & Airline */}
          <div style={{ marginTop: '-10px', fontSize: '2.3rem' }} className="design5-gate">Gate</div>
          <div style={{ marginTop: '25px', fontSize: '5.4rem' }} className="design5-gatenumber">{normalizeCode(flight?.loungeCode)}</div>
        </div>
      </div>

      {/* Second Column - Right Side Content */}
      <div className="design5-column2">
        <div className="design5-header">
          <div className="d-flex">
            <img
              src={`${BUCKET_URL}/0180x0045/P${flight?.flightNumber?.split(' ')[0]
                }13660200.bmp`}
              onError={(e) => {
                ; (
                  e.currentTarget as HTMLImageElement
                ).src = `${BUCKET_URL}/0180x0045/P${flight?.flightNumber?.split(' ')[0]
                }13660200.jpg`
              }}
              alt="Airline Logo" className="design5-alliance-logo" />
          </div>
        </div>
        <div className="design5-info">
          <h1 style={{ fontSize: '6.4rem' }} className="design5-flight-number">{flight.flightNumber}</h1>
          <div className="design5-codeshare-container ms-5">
            <AnimatedCodeshare mainClassName='d-flex align-items-center' labelClassName='ms-5 fs-large' codeShareFlights={flight.codeShareFlight} />
          </div>
          <h2 className="design5-destination mt-5"><Destination className='fs-large' flight={flight} /></h2>
          <FlipText className='ms-5 fs-large' dataList={getRemarksTranslation(RemarkToCodeMapping.GO_TO_GATE, flight.stations)} />
        </div>
      </div>
    </div>
  );
};

export default SingleFlightCheckIn;